import {FORMAT_HHMMSS, FORMAT_MMSS, secondsToTime} from './secondsToTime';

/**
 * Formats a timestamp into a time string based on the total duration.
 * Only formats the hours if the duration is longer than 60 minutes
 * e.g. timestamp: 10, duration: 70   -> 00:10
 * e.g. timestamp: 10, duration: 3600 -> 00:00:10
 * @param timestamp the number of seconds to format into a string
 * @param duration the total duration
 * @return {string} the formatted time string
 */
export const formatTimestampByDuration = (
  timestamp: number,
  duration: number
): string => {
  const hasHours = duration >= 3600;

  let format = FORMAT_MMSS;

  if (hasHours) format = FORMAT_HHMMSS;

  return secondsToTime(timestamp, format);
};
